import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectProfile, setProfile } from '../../slice/global.js';
import { CallApiPost, CallApiGet } from '../../apicalls/calls.js';
import Contrasena from './Contrasena.jsx';
import ValiteSession from '../../helpers/funciones.js';


export default function Perfil() {
    const UsuarioS = JSON.parse(window.localStorage.getItem('usuario'));
    const dispatch = useDispatch();
    const State = useSelector(selectProfile);


    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        return (() => {
            $("#backdrop").hide();
        })
    }, [State]);


    async function fetchData() {
        $("#backdrop").show();
       /*  if(await ValiteSession(UsuarioS.access_token)){
            console.log("token Valido")
        }else{
            window.location='/inicio';
            console.log("token caducado");
        } */
        var params = { id_usuario: UsuarioS.user.id }
        const Call = await CallApiGet('getInfoUser', params, UsuarioS.access_token);
        //console.log("fechProfile", Call);
        dispatch(setProfile(Call.success.users));
    }



    async function Save(values,actions) {
        $("#backdrop").show();
        var params = {
            contrasena: values.contrasena,
            id_usuario: UsuarioS.user.id,
            tipo_accion:'3'
        };
        const resp = await CallApiPost('actionUsers', params, UsuarioS.access_token);
        if (resp.status != 200) {
            window.Swal.fire({
                icon: 'error',
                title: 'Error',
                text: resp.error.message,
            });
            $("#backdrop").hide();
            $("#addSorteo").modal('hide')
        } else {
            //await fetchData();
            //dispatch(GetUsers(UsuarioS.access_token));
            actions.resetForm();
            $("#backdrop").hide();
            $("#addSorteo").modal('hide')
        }
    }
    //console.log("user",UsuarioS.user)
    return (
        <div className='container-fluid'>
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">Perfil</h1>
            </div>
            <div className='row'>
                <div className="col-xl-4">
                    <div className="card mb-4 mb-xl-0">
                        <div className="card-header py-3">
                            <h6 className="m-0 font-weight-bold" style={{ color: "#E6453B" }}>Usuario</h6>
                        </div>
                        <div className="card-body text-center">
                            <img className="img-account-profile rounded-circle mb-2" style={{ height: "17rem" }} src="/WebSorteosComp/img/undraw_profile.svg" alt="" />
                        </div>
                    </div>
                </div>
                <div className="col-xl-8" >
                    <div className="card mb-4">
                        <div className="card-header py-3">
                            <h6 className="m-0 font-weight-bold" style={{ color: "#E6453B" }}>Detalles del usuario</h6>
                        </div>
                        <div className="card-body">
                            <form>
                                {/* <!-- Form Group (username)--> */}
                                <div className="mb-3">
                                    <label className="small mb-1" htmlFor="inputUsername">Nombre</label>
                                    <input className="form-control" id="inputUsername" type="text" onChange={() => ''} value={State.nombre} />
                                </div>
                                {/* <!-- Form Row--> */}
                                {/*  <!-- Form Row        --> */}
                                <div className="row gx-3 mb-3">
                                    {/*  <!-- Form Group (organization name)--> */}
                                    <div className="col-md-12">
                                        <label className="small mb-1" htmlFor="inputOrgName">Direccion</label>
                                        <input className="form-control" id="inputOrgName" type="text" onChange={() => ''} value={State.direccion} />
                                    </div>
                                </div>
                                {/* <!-- Form Row--> */}
                                <div className="row gx-3 mb-3">
                                    <div className="col-md-4">
                                        <label className="small mb-1" htmlFor="inputPhone">Usuario</label>
                                        <input className="form-control" id="inputPhone" type="tel" onChange={() => ''} value={State.email} />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="small mb-1" htmlFor="inputBirthday">INE</label>
                                        <input className="form-control" id="inputBirthday" type="text" onChange={() => ''} name="birthday" value={State.ine} />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="small mb-1" htmlFor="inputBirthday">Teléfono</label>
                                        <input className="form-control" id="inputBirthday" type="text" name="birthday" onChange={() => ''} value={State.tel} />
                                    </div>
                                </div>
                                {/* <!-- Save changes button--> */}
                                <button className="btn btn-primary" type="button" onClick={() => $("#addSorteo").modal('show')}>Cambiar Contraseña</button>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
            <Contrasena Save={Save} />
        </div>
    )
}
